import generateFrontUri from "@raiden/library/libraries/utils/generateFrontUrl";
import { useIntl } from "react-intl";
import Seo from "../../components/Seo";
import { ContactUs } from "../../containers/ContactUs";

function Page() {
  const intl = useIntl();

  return (
    <>
      <Seo
        title={intl.formatMessage({ defaultMessage: "Nous contacter" })}
        description={intl.formatMessage({ defaultMessage: "Nous contacter" })}
        ogType="article"
        links={(locale) =>
          generateFrontUri({
            id: "@front.contact",
            parameters: {
              locale,
            },
          })
        }
        structuredData={{
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          headline: intl.formatMessage({ defaultMessage: "Nous contacter" }),
        }}
      />

      <ContactUs />
    </>
  );
}

export default Page;

/**
 * @typedef {import("../../types/Page").PageInitialProps} InitialProps
 */
/**
 * @param {import("../../types/AppContext").PageContext} context
 * @returns {Promise<InitialProps>}
 */
Page.getInitialProps = async function (context) {
  /** @type {InitialProps} */
  const values = {};

  return values;
};
